export default {
    rpc: {},
    types: {
        StatementKind: {
            _enum: ['Regular', 'Saft']
        }
    }
};
